'use client';

import React from 'react';
import ErrorBoundary from '#src/pages/ErrorBoundary';
import MessageBanner from '#src/components/MessageBanner/messageBanner';

const ClientLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <ErrorBoundary>
      <MessageBanner />
      {children}
    </ErrorBoundary>
  );
};

export default ClientLayout;
